import { render } from "./CardRoulette.vue?vue&type=template&id=6a823f32&scoped=true"
import script from "./CardRoulette.vue?vue&type=script&lang=js"
export * from "./CardRoulette.vue?vue&type=script&lang=js"

import "./CardRoulette.vue?vue&type=style&index=0&id=6a823f32&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a823f32"]])

export default __exports__